"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Renderables is a simple registry to register renderables.
 */
var Renderables = /** @class */ (function () {
    function Renderables() {
    }
    /**
     * Registers the property in the registry
     *
     * @param name the renderables name
     * @param renderable the renderables class
     */
    Renderables.register = function (name, renderable) {
        this.renderableMap[name.toUpperCase()] = renderable;
    };
    /**
     * Returns the renderable from the registry
     *
     * @param name the renderables name
     */
    Renderables.resolve = function (name) {
        return this.renderableMap[name.toUpperCase()];
    };
    /**
     * The map where the renderables are stored
     */
    Renderables.renderableMap = {};
    return Renderables;
}());
exports.default = Renderables;
